import Cookies from 'js-cookie';

export default class Messengers {
    constructor() {
        $(".messenger-widget").on('click', function (e) {
            e.preventDefault();
            $(".messenger-items").toggleClass("messengers-hide");
            $(".messengers-layer").toggleClass("messengers-open");

            if ($(".messenger-items").hasClass("messengers-hide")) {
                Cookies.set('closeMessengers', 1, {expires: 30});
            } else {
                Cookies.remove('closeMessengers');
            }
        });
    }
}